import { TYPES } from "./task_effort.type";

const initState = {
  taskEffortAll: null,
  taskEffortOpenAdd: false,
  taskEffortOpenEdit: false,
  taskEffortSelected: null,
  taskEffortSearch: "",
  //
  taskEffortCountPass: 0,
  taskEffortCountWarn: 0,
  taskEffortCountDeny: 0,
  taskEffortSumExp: 0,
  taskEffortSumEffort: 0,
  taskEffortSumEase: 0,
  taskEffortSumMistake: 0,
};

const taskEffortReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.SET_TASK_EFFORT_ALL:
      return {
        ...state,
        taskEffortAll: payload,
      };

    case TYPES.SET_TASK_EFFORT_OPEN_ADD:
      return {
        ...state,
        taskEffortOpenAdd: payload,
      };

    case TYPES.SET_TASK_EFFORT_OPEN_EDIT:
      return {
        ...state,
        taskEffortOpenEdit: payload,
      };

    case TYPES.SET_TASK_EFFORT_SELECTED:
      return {
        ...state,
        taskEffortSelected: payload,
      };

    case TYPES.SET_TASK_EFFORT_SEARCH:
      return {
        ...state,
        taskEffortSearch: payload,
      };

    //
    case TYPES.SET_TASK_EFFORT_COUNT_PASS:
      return {
        ...state,
        taskEffortCountPass: payload,
      };

    case TYPES.SET_TASK_EFFORT_COUNT_WARN:
      return {
        ...state,
        taskEffortCountWarn: payload,
      };

    case TYPES.SET_TASK_EFFORT_COUNT_DENY:
      return {
        ...state,
        taskEffortCountDeny: payload,
      };

    case TYPES.SET_TASK_EFFORT_SUM_EXP:
      return {
        ...state,
        taskEffortSumExp: payload,
      };

    case TYPES.SET_TASK_EFFORT_SUM_EASE:
      return {
        ...state,
        taskEffortSumEase: payload,
      };

    case TYPES.SET_TASK_EFFORT_SUM_EFFORT:
      return {
        ...state,
        taskEffortSumEffort: payload,
      };

    case TYPES.SET_TASK_EFFORT_SUM_MISTAKE:
      return {
        ...state,
        taskEffortSumMistake: payload,
      };

    default:
      return state;
  }
};

export default taskEffortReducer;
